import useKeyboardShortcut from "./useKeyboardShortcut"
export { cmdOrCtrl } from "./useKeyboardShortcut"
export { type Key, Keys } from "./types"
export default useKeyboardShortcut
